import { Box } from '@mui/material';
import {
  Dashboard,
  DashboardCreate,
  mapDashboardToDashboardCreate,
} from '@src/main/modules/common/dashboard/domain/Dashboard';
import AdminAddDashboardConfirmDeleteModal from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboards/AdminAddDashboardConfirmDeleteModal/AdminAddDashboardConfirmDeleteModal';
import AdminAddDashboardModal from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboards/AdminAddDashboardModal/AdminAddDashboardModal';
import DashboardsList from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardsList';
import FabButton from '@src/main/ui/components/common/buttons/FabButton';
import { FC, useState } from 'react';
import styles from './AdminAddDashboards.module.scss';

interface Props {
  items: Dashboard[];
  actions: {
    add: boolean;
    edit: boolean;
    delete: boolean;
  };
}

const AdminAddDashboards: FC<Props> = ({ items, actions }) => {
  const [modal, setModal] = useState<{ open: boolean; dashboard: DashboardCreate | null }>({
    open: false,
    dashboard: null,
  });

  const [modalConfirmDelete, setModalConfirmDelete] = useState<{
    open: boolean;
    dashboard: Dashboard | null;
  }>({
    open: false,
    dashboard: null,
  });

  return (
    <Box className={styles.container}>
      <DashboardsList
        dashboards={items}
        isExpandable={false}
        actions={{
          edit: actions.edit,
          delete: actions.delete,
        }}
        onClickEdit={(dashboard) =>
          setModal({ open: true, dashboard: mapDashboardToDashboardCreate(dashboard) })
        }
        onClickDelete={(dashboard) => {
          setModalConfirmDelete({
            open: true,
            dashboard,
          });
        }}
      />
      {actions.add && (
        <FabButton
          onClick={() =>
            setModal({
              open: true,
              dashboard: null,
            })
          }
          icon="add"
        />
      )}
      {modal.open && (
        <AdminAddDashboardModal
          onClose={() =>
            setModal({
              open: false,
              dashboard: null,
            })
          }
          dashboard={modal.dashboard}
        />
      )}
      {modalConfirmDelete.open && modalConfirmDelete.dashboard && (
        <AdminAddDashboardConfirmDeleteModal
          onClose={() =>
            setModalConfirmDelete({
              open: false,
              dashboard: null,
            })
          }
          dashboard={modalConfirmDelete.dashboard}
        />
      )}
    </Box>
  );
};
export default AdminAddDashboards;
